/* eslint-disable */
import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);
export default new Vuetify({});



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js